/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_NewInputs */



/**
* | output |
* | --- |
* | "New promo" |
*
* @param {Promo_NewInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_new = /** @type {((inputs?: Promo_NewInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_NewInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouvelle promo")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nueva promo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nova promo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuova promo")
	return /** @type {LocalizedString} */ ("New promo")
});